import { NotificationsNoneRounded } from '@mui/icons-material';
import { useAuth } from 'framework/base/authorization/AuthorizationProvider';
import useSystemSettingsContext from 'framework/base/hooks/useSystemSettingsContext';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import React, { Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AryLoadingAnimation from '../AryLoadingAnimation';
import AryWhatsappInitializationModal from '../AryWhatsappInitializationModal';
import SwitchableChip from './SwitchableChip';

const WhatsappChips = ({
  isPublishToWhatsAppValue,
  handleChangeIsPublishToWhatsapp
}) => {
  const auth = useAuth();
  const { WhatsappConnectionR } = auth;
  const { t } = useFrameworkTranslation();
  const { systemSettings } = useSystemSettingsContext();
  const { isWhatsappEnabled, isTelegramEnabled } = systemSettings;
  // const dispatch = useDispatch();

  const [whatsappInitializationModalOpen, setWhatsappInitializationModalOpen] =
    useState(false);

  const { isLogin } = useSelector((state) => state.systemReducer?.whatsapp);

  useEffect(() => {
    if (isWhatsappEnabled && !isLogin) {
      handleChangeIsPublishToWhatsapp(false);
    }
  }, [isLogin]);

  return (
    <>
      <SwitchableChip
        title={t('PublishTransactionInWhatsapp')}
        value={isLogin === true || isTelegramEnabled ? isPublishToWhatsAppValue : false}
        handleClick={() => {
          if (isLogin || isTelegramEnabled) {
            handleChangeIsPublishToWhatsapp(!isPublishToWhatsAppValue);
          } else if (WhatsappConnectionR && isWhatsappEnabled) {
            setWhatsappInitializationModalOpen(true);
          }
        }}
        // loading={isLoading}
        Icon={NotificationsNoneRounded}
      />
      {whatsappInitializationModalOpen && (
        <Suspense fallback={<AryLoadingAnimation />}>
          <AryWhatsappInitializationModal
            open={whatsappInitializationModalOpen}
            handleClose={() => setWhatsappInitializationModalOpen(false)}
          />
        </Suspense>
      )}
    </>
  );
};

export default WhatsappChips;
